// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uc2U","col":"styles_col__VuRHV"};